import { render, staticRenderFns } from "./F10.vue?vue&type=template&id=cdcead8e&scoped=true"
import script from "./F10.vue?vue&type=script&lang=js"
export * from "./F10.vue?vue&type=script&lang=js"
import style0 from "./F10.vue?vue&type=style&index=0&id=cdcead8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcead8e",
  null
  
)

export default component.exports